import React from 'react';
import classNames from 'classnames';
import { TennistalkerIcon, TennistalkerIconFull } from './SocialIcons';

const Logo: React.FC = () => {
  const className = classNames(
    'flex',
    'items-center',
    'border',
    'border-solid',
    'border-accent-accent-6',
    'hover:border-accent-accent-8',
    'hover:bg-accent-accent-3',
    'hover:rounded-xl',
    'cursor-pointer',
    'w-4/5',
  );
  return (
    <div className={className}>
      <div className='hidden md:block'>
        <TennistalkerIconFull className='w-full' />
      </div>
      <div className='md:hidden'>
        <TennistalkerIcon />
      </div>
    </div>
  );
};

export default Logo;
